import React from 'react';

import CustomTd from '../shared/table/CustomTd';
import EditDeleteButton from '../shared/buttons/EditDeleteButton';
import PropTypes from 'prop-types';

const CustomerSearchItem = ({
    editItem,
    item
}) => {
    return (
        <tr>
            <CustomTd className="d-none d-xl-table-cell">
                {item.firstName}
            </CustomTd>
            <CustomTd className="d-none d-xl-table-cell">
                {item.lastName}
            </CustomTd>
            <CustomTd className="d-xl-none">
                {item.firstName.slice(0, 1) + '. ' + item.lastName}
            </CustomTd>
            <CustomTd className="d-none d-sm-table-cell">
                {item.email1}
            </CustomTd>
            <CustomTd className="d-none d-md-table-cell">
                {item.addressLine1}
            </CustomTd>
            <CustomTd>
                {item.city}
            </CustomTd>
            <CustomTd className="d-none d-lg-table-cell">
                {item.stateName}
            </CustomTd>
            <CustomTd className="d-none d-lg-table-cell">
                {item.zip}
            </CustomTd>
            <CustomTd className="d-none d-sm-table-cell">
                {item.primaryPhone}
            </CustomTd>
            {window.biztrax.showFranchise &&
                <CustomTd className="d-none d-lg-table-cell">
                    {item.franchiseName}
                </CustomTd>
            }
            <CustomTd className="button-cell">
                <EditDeleteButton
                    canDelete={false}
                    showDelete={false}
                    viewItem={editItem}
                    editItem={editItem}
                    showText={false}
                    acl={item.acl}
                />
            </CustomTd>
        </tr>
    );
}

CustomerSearchItem.propTypes = {
    deleteUrl: PropTypes.string,
    editItem: PropTypes.func,
    fetchData: PropTypes.func,
    showFranchise: PropTypes.bool
};

export default CustomerSearchItem;